var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAndroidCircle = function SvgAndroidCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 25"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.207,
    cy: 12.1797,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M15.707 10.6053L16.857 8.61775C16.957 8.424 16.882 8.1865 16.6945 8.0865C16.5133 7.99275 16.2883 8.049 16.1758 8.224L15.0008 10.249C13.2133 9.49275 11.2008 9.49275 9.41328 10.249L8.23828 8.224C8.11953 8.04275 7.87578 7.9865 7.69453 8.099C7.51953 8.2115 7.46328 8.4365 7.55703 8.61775L8.70703 10.6053C6.76953 11.7115 5.50703 13.7053 5.33203 15.9303H19.082C18.907 13.7053 17.6445 11.7115 15.707 10.6053ZM9.08203 14.2115C8.65078 14.2115 8.30078 13.8615 8.30078 13.4303C8.30078 12.999 8.65078 12.649 9.08203 12.649C9.51328 12.649 9.86328 12.999 9.86328 13.4303C9.86328 13.8615 9.51328 14.2115 9.08203 14.2115ZM15.332 14.2115C14.9008 14.2115 14.5508 13.8615 14.5508 13.4303C14.5508 12.999 14.9008 12.649 15.332 12.649C15.7633 12.649 16.1133 12.999 16.1133 13.4303C16.1133 13.8615 15.7633 14.2115 15.332 14.2115Z"
  })));
};
export default SvgAndroidCircle;